export function parseFutureActionsDeepLink(search) {
  const params = new URLSearchParams(search || '');
  const moldInfoIdRaw = params.get('moldInfoId');
  const futureActionIdRaw = params.get('futureActionId');
  const moldInfoId = moldInfoIdRaw ? Number(moldInfoIdRaw) : null;
  const futureActionId = futureActionIdRaw ? Number(futureActionIdRaw) : null;

  if (!Number.isFinite(moldInfoId) || moldInfoId <= 0) {
    return null;
  }

  return {
    moldInfoId,
    futureActionId:
      Number.isFinite(futureActionId) && futureActionId > 0 ? futureActionId : null,
  };
}

export function normalizeFutureActionMold(mold) {
  if (!mold || typeof mold !== 'object') {
    return null;
  }

  return {
    ...mold,
    moldInfoID: mold.moldInfoID ?? mold.MoldInfoID ?? mold.id ?? null,
    toolID: mold.toolID ?? mold.ToolID ?? '',
    moldNumber: mold.moldNumber ?? mold.MoldNumber,
    moldDescription: mold.moldDescription ?? mold.MoldDescription ?? mold.description,
  };
}
